<h1 class="sr-only">{{ h1 }}</h1>
@if (dto) {
  @if (dto.popular?.length) {
    <app-card>
      <app-card-header>Популярные материалы</app-card-header>
      <app-card-body>
        <div class="flex flex-wrap justify-between gap-2.5 [&>*]:basis-[calc(25%_-_20px)] [&>*]:overflow-hidden [&>*]:rounded-lg [&>*]:bg-[var(--bg-color)] max-[1366px]:[&>*]:basis-[calc(33%_-_20px)] max-[768px]:[&>*]:basis-[calc(50%_-_10px)] max-[320px]:[&>*]:basis-full">
          @for (news of dto.popular; track news.id) {
            <app-homepage-block-item [news]="news"
              />
          }
        </div>
      </app-card-body>
    </app-card>
  }
  <!-- курсы — только когда раздел включён и есть что показать -->
  @if (topCourses.length) {
    <app-card>
      <app-card-header>
        Популярные курсы
        <a class="ml-2 text-[0.85em] font-normal" [routerLink]="['/', r.courses]">Все курсы →</a>
      </app-card-header>
      <app-card-body>
        <div class="flex flex-wrap justify-between gap-2.5 [&>*]:basis-[calc(25%_-_20px)] [&>*]:overflow-hidden [&>*]:rounded-lg [&>*]:bg-[var(--bg-color)] max-[1366px]:[&>*]:basis-[calc(33%_-_20px)] max-[768px]:[&>*]:basis-[calc(50%_-_10px)] max-[320px]:[&>*]:basis-full">
          @for (c of topCourses; track c.id) {
            <a class="flex h-full min-h-[250px] flex-col gap-2.5 text-inherit no-underline [&.no-image]:items-center [&.no-image]:justify-center [&_img]:block [&_img]:max-h-[200px] [&_img]:w-full [&_img]:object-cover [&_img]:object-center" [routerLink]="['/', r.courses, c.slug]"
               [class.no-image]="!c.mainThumb">
              @if (c.mainThumb) {
                <img [src]="imagesPath + '/' + c.mainThumb"
                     [alt]="'превью курса ' + c.name" loading="lazy">
              }
              <div class="p-2.5">{{c.name}}
                @if (c.isFree) { <span class="ml-1.5 text-[0.85em] font-semibold text-[var(--success-bg-text)]">бесплатный</span> }
              </div>
            </a>
          }
        </div>
      </app-card-body>
    </app-card>
  }
  @if (lastCourses.length) {
    <app-card>
      <app-card-header>
        Новые курсы
        <a class="ml-2 text-[0.85em] font-normal" [routerLink]="['/', r.courses]">Все курсы →</a>
      </app-card-header>
      <app-card-body>
        <div class="flex flex-wrap justify-between gap-2.5 [&>*]:basis-[calc(25%_-_20px)] [&>*]:overflow-hidden [&>*]:rounded-lg [&>*]:bg-[var(--bg-color)] max-[1366px]:[&>*]:basis-[calc(33%_-_20px)] max-[768px]:[&>*]:basis-[calc(50%_-_10px)] max-[320px]:[&>*]:basis-full">
          @for (c of lastCourses; track c.id) {
            <a class="flex h-full min-h-[250px] flex-col gap-2.5 text-inherit no-underline [&.no-image]:items-center [&.no-image]:justify-center [&_img]:block [&_img]:max-h-[200px] [&_img]:w-full [&_img]:object-cover [&_img]:object-center" [routerLink]="['/', r.courses, c.slug]"
               [class.no-image]="!c.mainThumb">
              @if (c.mainThumb) {
                <img [src]="imagesPath + '/' + c.mainThumb"
                     [alt]="'превью курса ' + c.name" loading="lazy">
              }
              <div class="p-2.5">{{c.name}}
                @if (c.isFree) { <span class="ml-1.5 text-[0.85em] font-semibold text-[var(--success-bg-text)]">бесплатный</span> }
              </div>
            </a>
          }
        </div>
      </app-card-body>
    </app-card>
  }
  @if (dto.mostCommented?.length) {
    <app-card>
      <app-card-header>Наиболее комментируемые материалы</app-card-header>
      <app-card-body>
        <div class="flex flex-wrap justify-between gap-2.5 [&>*]:basis-[calc(25%_-_20px)] [&>*]:overflow-hidden [&>*]:rounded-lg [&>*]:bg-[var(--bg-color)] max-[1366px]:[&>*]:basis-[calc(33%_-_20px)] max-[768px]:[&>*]:basis-[calc(50%_-_10px)] max-[320px]:[&>*]:basis-full">
          @for (news of dto.mostCommented; track news.id) {
            <app-homepage-block-item [news]="news"
              />
          }
        </div>
      </app-card-body>
    </app-card>
  }
  @if (dto.last?.length) {
    <app-card>
      <app-card-header>Последние добавленные материалы</app-card-header>
      <app-card-body>
        <div class="flex flex-wrap justify-between gap-2.5 [&>*]:basis-[calc(25%_-_20px)] [&>*]:overflow-hidden [&>*]:rounded-lg [&>*]:bg-[var(--bg-color)] max-[1366px]:[&>*]:basis-[calc(33%_-_20px)] max-[768px]:[&>*]:basis-[calc(50%_-_10px)] max-[320px]:[&>*]:basis-full">
          @for (news of dto.last; track news.id) {
            <app-homepage-block-item [news]="news"
              />
          }
        </div>
      </app-card-body>
    </app-card>
  }
} @else if (!failed) {
  <app-cards-skeleton [count]="3" [children]="4" variant="tiles"/>
}

